import React from "react";
import { Link } from "react-router-dom";

import { SHOP } from "../config";
import logoMark from "../img/logo.svg";

// The site footer: a brand blurb, contact details, quick links and the legal
// links. Rendered near the bottom of every page, just above the slim copyright
// bar (components/Footer). The legal pages pass "additional-pages-footer".
const InfoFooter = ({ className = "" }) => (
  <div className={`info-footer-container${className ? ` ${className}` : ""}`}>
    <div className="info-footer">
      <div className="footer-brand">
        <Link to="/" className="footer-logo">
          <img className="logo-mark" src={logoMark} alt="" aria-hidden="true" />
          Optika Volyně
        </Link>
        <p className="footer-tagline">
          Vaše známá optika na náměstí ve Volyni — brýle, čočky a odborná péče
          o zrak s dlouholetou tradicí.
        </p>
        <a
          className="footer-social"
          href={SHOP.facebook}
          target="_blank"
          rel="noreferrer"
          aria-label="Facebook"
        >
          <i className="fa fa-facebook" />
        </a>
      </div>

      <div className="footer-col">
        <h3>Kontakt</h3>
        <p>{SHOP.owner}</p>
        <a href={`tel:${SHOP.phone}`}>{SHOP.phoneDisplay}</a>
        <a href={`mailto:${SHOP.email}`}>{SHOP.email}</a>
        <p>{SHOP.address}</p>
        <p>IČO: {SHOP.ico}</p>
      </div>

      <div className="footer-col footer-col-nav">
        <h3>Navigace</h3>
        <Link to="/sluzby">Sortiment</Link>
        <Link to="/novinky">Novinky</Link>
        <Link to="/galerie">Galerie</Link>
        <Link to="/reference">Reference</Link>
        <Link to="/kontakt">Kontakt</Link>
      </div>

      <div className="footer-col">
        <h3>Informace</h3>
        <Link to="/cookies">Používání cookies</Link>
        <Link to="/autorska-prava">Autorská práva</Link>
        <a href={SHOP.reservio} target="_blank" rel="noreferrer">
          Rezervace online
        </a>
      </div>
    </div>
  </div>
);

export default InfoFooter;
